// extracted by css-extract-rspack-plugin
export default {"modulesContainer":"modulesContainer-BVDFgz","moduleSection":"moduleSection-BwbBVZ","sectionTitle":"sectionTitle-CdwYcr","emptyState":"emptyState-SrAiXS"};